import { useCallback, useMemo } from "react";
import {
	getDefaultLayoutFromDatabase,
	getLayoutByType,
	getLayoutFromDatabase,
} from "../services/layout.service";
import { parseLayoutFromApiResponse } from "../utils/parseLayoutApiResponse";

/**
 * Shared layout GET helpers for dashboard pages (same endpoints, same response shape).
 * Returns parsed `layout` from the API or `undefined` when missing.
 */
export function usePageLayoutFetch(pageType) {
	const fetchSavedLayout = useCallback(
		async (layoutType = "personal") => {
			const response = await getLayoutFromDatabase(pageType, layoutType);
			return parseLayoutFromApiResponse(response);
		},
		[pageType]
	);

	const fetchLayoutByType = useCallback(
		async (layoutType = "personal") => {
			const response = await getLayoutByType(pageType, layoutType);
			return parseLayoutFromApiResponse(response);
		},
		[pageType]
	);

	const fetchDefaultLayout = useCallback(async () => {
		const response = await getDefaultLayoutFromDatabase(pageType);
		return parseLayoutFromApiResponse(response);
	}, [pageType]);

	return useMemo(
		() => ({
			fetchSavedLayout,
			fetchLayoutByType,
			fetchDefaultLayout,
		}),
		[fetchSavedLayout, fetchLayoutByType, fetchDefaultLayout]
	);
}
